<template>
  <div>
    <van-cell-group>
      <van-cell
        title-class="cell-title"
        value-class="cell-value"
        title="卡券编码"
        :border="false"
        center
      >
        {{ couponInfo.couponCode }}
        <div
          v-if="
            (couponInfo.couponStatus === '2'||couponInfo.couponStatus === '1' )&&
              (couponInfo.status === '1'||couponInfo.status === '0') &&
              hasAfterSaleRecord
          "
          style="color:#FF714F"
          @click="toCouponAfterSale(couponInfo)"
        >
          <div v-if="couponInfo.afterSalesStatus === '0'">已发起退款申请</div>
          <div v-else-if="couponInfo.afterSalesStatus === '1'">
            客服同意退款,财务审核中
          </div>
          <div v-else-if="couponInfo.afterSalesStatus === '2'">售后完成</div>
          <div v-else-if="couponInfo.afterSalesStatus === '3'">拒绝退款</div>
          <div v-else-if="couponInfo.afterSalesStatus === '4'">取消退款申请</div>
          <div v-else>售后完成</div>
        </div>
      </van-cell>
      <van-cell
        title="指定商品"
        :value="couponInfo.designatedGoods"
        title-class="cell-title"
        value-class="cell-value"
        :border="false"
      ></van-cell>
      <van-cell
        title="卡券日期"
        :value="couponInfo.startTime + '-' + couponInfo.endTime"
        title-class="cell-title"
        value-class="cell-value"
        :border="false"
        center
      ></van-cell>
      <van-cell
        title="激活时间"
        v-if="couponInfo.status === '1' || couponInfo.status === '3'"
        :value="
          couponInfo.couponStatus === '1' ? '待激活' : couponInfo.activationTime
        "
        title-class="cell-title"
        value-class="cell-value"
        :border="false"
        center
      ></van-cell>
    </van-cell-group>

    <van-cell-group
      style="margin-top:8px"
      v-if="
        (couponInfo.status === '1' && couponInfo.couponStatus !== '2') ||
          (couponInfo.status === '3' && couponInfo.couponStatus !== '1')
      "
    >
      <van-cell
        title="绑定用户"
        :value="couponInfo.userId"
        title-class="cell-title"
        value-class="cell-value"
        :border="false"
        center
      ></van-cell>
      <van-cell
        title="兑换情况"
        :value="couponInfo.couponStatus == '4' ? '已兑换' : '未兑换'"
        title-class="cell-title"
        value-class="cell-value"
        :border="false"
        center
      ></van-cell>
      <van-cell
        title="兑换时间"
        v-if="couponInfo.couponStatus == '4'"
        :value="couponInfo.useTime"
        title-class="cell-title"
        value-class="cell-value"
        :border="false"
        center
      ></van-cell>
      <van-cell
        title="兑换方式"
        v-if="couponInfo.couponStatus == '4'"
        :value="couponInfo.couponType"
        title-class="cell-title"
        value-class="cell-value"
        :border="false"
        center
      ></van-cell>
    </van-cell-group>

    <van-button
      class="active-btn"
      v-if="couponInfo.status === '0'"
      @click="toActivateCoupon"
      color="#c59a56"
      >去激活</van-button
    >
    <van-button
      class="active-btn"
      v-if="
        couponInfo.status === '1' &&
          couponInfo.couponStatus === '2' &&
          couponInfo.soFar <= 7
      "
      @click="revoke(couponInfo)"
      color="#c59a56"
      >申请退款</van-button
    >
  </div>
</template>

<script>
import {queryPost} from "@/api/common"
export default {
  data() {
    return {
      couponInfo: this.$route.query,
      hasAfterSaleRecord:false
    };
  },
  created(){
    this.getAfterSaleRecord()
  },
  methods: {
    toCouponAfterSale(obj) {
      this.$router.push({ path: "/couponAfterSale", query: obj });
    },
    //前往激活提货卡
    toActivateCoupon() {
      this.$router.push({ path: "/activateCoupon", query: this.couponInfo });
    },
    revoke(obj) {
      this.$router.push({ path: "/couponRefund", query: obj });
    },
    getAfterSaleRecord() {
      let url = "order/couponBusiness/queryCouponAfterSaleRecord";
      let params = {
        couponId: this.couponInfo.id
      };
      queryPost(url, params).then(async res => {
        var afterSaleResult = res.data.data.results;

        if(afterSaleResult.length > 0) {
          this.hasAfterSaleRecord=true
        }
      });
    },
  }
};
</script>

<style lang="less" scoped>
.cell-title {
  flex: none;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
}
.cell-value {
  text-align: left;
  margin-left: 16px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
}
.active-btn {
  width: 120px;
  height: 32px;
  border-radius: 2px;
  border: 1px solid #c59a56;
  margin-top: 32px;
  left: 50%;
  transform: translateX(-50%);
}
</style>
